import React, { useState } from 'react';
import { useEffect } from 'react';
import '../styles/ProductPage.css';

const ProductPage = () => {

  useEffect(() => {
    (function(d, w, c) {
      w.ChatraID = 'XsYGMCQ4ANZregsLE';
      var s = d.createElement('script');
      w[c] = w[c] || function() {
        (w[c].q = w[c].q || []).push(arguments);
      };
      s.async = true;
      s.src = 'https://call.chatra.io/chatra.js';
      if (d.head) d.head.appendChild(s);
    })(document, window, 'Chatra');
  }, []);


  const [selectedTab, setSelectedTab] = useState('overview');

  // Simple Download Icon Component
  const DownloadIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7,10 12,15 17,10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );

  const product = {
    id: 1,
    name: "Aurora End Suction Pump",
    model: "3800 Series",
    badge: "",
    image: "/images/auroraendsuction.png",
    features: [
      "NSF 50 or 61 Certified",
      "Up to 5000 GPM",
      "Ductile Iron casting",
      "Flex coupled",
      "Standard JM and JP motors",
      "Up to 520 foot heads",
      "Withstands Up to 300 degrees F",
    ],
    specifications: {
      "Flow Rate": "1500-5000 GPM",
      "Pressure": "97-261 PSI",
      "Material": "Ductile Iron Bronze Filled",
      "Drive Type": "Electric motor or diesel driven",
      "Coupling": "Flex coupled",
      "Centerline": "Common flange",
      "Bearing Housing": "Bolt-on design",
      "Certifications": "UL, ULC, FM and ANSI"
    }
  };

  const tabs = {
    overview: "Overview",
    performance: "Performance Curves",
    technical: "Technical Drawings",
    documentation: "Documentation & Tools"
  };

  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      {/* Breadcrumb Navigation */}
      <div style={{ 
        maxWidth: '1400px', 
        margin: '0 auto', 
        padding: '1rem 2rem 0 2rem',
        backgroundColor: 'white'
      }}>
        <nav className="product-breadcrumb">
          <a href="/products" className="breadcrumb-link">Products</a>
          <span className="breadcrumb-separator"> › </span>
          <span className="breadcrumb-current">Aurora End Suction</span>
        </nav>
      </div>

      <div className="product-page-container">
        {/* Product Title */}
        <div className="product-header-section">
          <h1 className="product-main-title">{product.name}</h1>
        </div>

        {/* Tabs Navigation */}
        <div className="product-tabs-navigation">
          <ul className="product-tab-list">
            {Object.entries(tabs).map(([key, label]) => (
              <li key={key}>
                <button 
                  className={`product-tab-button ${selectedTab === key ? 'active' : ''}`}
                  onClick={() => setSelectedTab(key)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Tab Content */}
        <div className="product-tab-content">
          {selectedTab === 'overview' && (
            <div className="product-overview-content">
              {/* Left side - Large product image */}
              <div className="product-left-content">
                <div className="product-detail-card product-image-card">
                  {product.badge && (
                    <span className="product-detail-badge ul-listed">{product.badge}</span>
                  )}
                  <div className="product-image-container">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="product-main-image"
                    />
                  </div>
                </div>
              </div>

              {/* Right side - Stacked cards */}
              <div className="product-right-sidebar">
                {/* Learn More card */}
                <div className="product-learn-more-card">
                  <h3 className="product-learn-more-title">LEARN MORE</h3>
                  <p className="product-learn-more-text">Whether you would like additional information or are interested in getting a quote, we're here to help.</p>
                  <a href="/contact" className="product-info-request-btn">REQUEST INFORMATION</a>
                </div>

                {/* Configure Pump card */}
                <div className="product-build-pump-card">
                  <h3 className="product-build-pump-title">CONFIGURE YOUR PUMP</h3>
                  <p className="product-build-pump-text">Build your custom pump configuration to meet your specific needs.</p>
                  <a href="https://pentair.intelliquip.com/Party/application/cookieconsent/openaccesslogin?afterConsentUrl=https%3A%2F%2Fpentair.intelliquip.com%2FIEQ_HydSel%2FHydSel_JSP%2FApp%2Fstart%3FselectionRefresh%3Dtrue%26entryType%3Dselector%26returnURL%3Dhttp%253A%252F%252Fwww.aurorapump.com%26UID%3D87d62feb377be201c1e35ed59d8d70b1%26quantityItems%3D1%26isRequestFromEntryServlet%3Dyes&UID=87d62feb377be201c1e35ed59d8d70b1" className="product-build-pump-btn" target="_blank" rel="noopener noreferrer">BUILD YOUR CONFIGURATION</a>
                </div>

                {/* Features card */}
                <div className="product-features-card">
                  <h3 className="product-features-title">PRODUCT FEATURES</h3>
                  <ul className="product-features-list">
                    {product.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Description content below - full width */}
              <div className="product-description-section">
                <div className="product-description-content">
                  <p>When it's time to move liquid from place to place, the Aurora 3800 Series is game. Here are just some of the features of these industry-leading pumps:</p>
                  <p>The Aurora 3800 Series comes NSF 372 certified, with options for NSF 50 certified or NSF 61 certified, depending on the application.</p>
                </div>
              </div>
            </div>
          )}

          {selectedTab === 'performance' && (
            <div className="product-tab-panel">
              <div className="pump-filter-container">
                <div className="filter-layout">
                  {/* Left Sidebar - Filters */}
                  <div className="filter-sidebar">
                    <div className="filter-header">
                      <h3>Filter list</h3>
                      <button className="reset-btn">Reset</button>
                      <span className="results-count">11 Results</span>
                    </div>

                    {/* Pump Type Filter */}
                    <div className="filter-section">
                      <div className="filter-title">
                        <span>Pump type</span>
                        <span className="expand-icon">⌄</span>
                      </div>
                      <div className="filter-options">
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">8x6x14F (5)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">8x6x15F (3)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">16x10x22F (3)</span>
                        </label>
                        <button className="show-more-btn">Show more ⌄</button>
                      </div>
                    </div>

                    {/* Product Name Filter */}
                    <div className="filter-section">
                      <div className="filter-title">
                        <span>Product name</span>
                        <span className="expand-icon">⌄</span>
                      </div>
                      <div className="filter-options">
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">3800 Series 3800 (4)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">3800 Series 3802 (3)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">3800 Series 3804 (4)</span>
                        </label>
                        <button className="show-more-btn">Show all ⌄</button>
                      </div>
                    </div>

                    {/* Flow Rate Filter */}
                    <div className="filter-section">
                      <div className="filter-title">
                        <span>Flow rate</span>
                        <span className="expand-icon">⌄</span>
                      </div>
                      <div className="filter-options">
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">1000-1500 GPM (3)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">3000-4000 GPM (4)</span>
                        </label>
                        <label className="filter-option">
                          <input type="checkbox" />
                          <span className="checkbox-custom"></span>
                          <span className="option-text">4500-5000 GPM (4)</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Curves Table */}
                  <div className="curves-section">
                    <div className="table-container">
                      <table className="curves-table">
                        <thead>
                          <tr>
                            <th className="curve-column">Curve</th>
                            <th>Product name ↕</th>
                            <th>Flow Rate<br/>[GPM] ↕</th>
                            <th>RPM ↕</th>
                            <th>Size ↕</th>
                            <th>File Size ↕</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            { name: "1000 GPM 8x6x14F-S 3800 Series 3801", flow: "1000", rpm: "2950", size: "8x6x14F", fileSize: "19.96 kB" },
                            { name: "1250 GPM 8x6x14F-S 3800 Series 3801", flow: "1250", rpm: "2950", size: "8x6x14F", fileSize: "19.96 kB" },
                            { name: "1500 GPM 8x6x15F 3800 Series 3801", flow: "1500", rpm: "2950", size: "8x6x15F", fileSize: "190.2 kB" },
                            { name: "3000 GPM 16x10x22F 3800 Series 3801", flow: "3000", rpm: "1485", size: "16x10x22F", fileSize: "19.82 kB" },
                            { name: "3500 GPM 16x10x22F 3800 Series 3801", flow: "3500", rpm: "1485", size: "16x10x22F", fileSize: "19.83 kB" },
                            { name: "4000 GPM 16x10x22F 3800 Series 3801", flow: "4000", rpm: "1485", size: "16x10x22F", fileSize: "19.83 kB" },
                            { name: "4000 GPM 16x10x22F 3800 Series 3804", flow: "4000", rpm: "1785", size: "16x10x22F", fileSize: "21.02 kB" },
                            { name: "4500 GPM 16x10x22F 3800 Series 3804", flow: "4500", rpm: "1485", size: "16x10x22F", fileSize: "19.82 kB" },
                            { name: "4500 GPM 16x10x22F 3800 Series 3804", flow: "4500", rpm: "1785", size: "16x10x22F", fileSize: "21.02 kB" },
                            { name: "5000 GPM 16x10x22F 3800 Series 3804", flow: "5000", rpm: "1485", size: "16x10x22F", fileSize: "19.66 kB" },
                            { name: "5000 GPM 16x10x22F 3800 Series 3804", flow: "5000", rpm: "1785", size: "16x10x22F", fileSize: "21.01 kB" }
                          ].map((curve, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                              <td className="curve-cell">
                                <svg width="30" height="20" viewBox="0 0 30 20" className="curve-icon">
                                  <path 
                                    d="M2 16 Q8 4 15 8 Q22 12 28 4" 
                                    stroke="#09244f" 
                                    strokeWidth="1.5" 
                                    fill="none"
                                  />
                                  <circle cx="5" cy="14" r="1" fill="#09244f"/>
                                  <circle cx="15" cy="8" r="1" fill="#09244f"/>
                                  <circle cx="25" cy="6" r="1" fill="#09244f"/>
                                </svg>
                              </td>
                              <td className="product-name">
                                <a href="#" className="product-link">{curve.name}</a>
                              </td>
                              <td className="centered">{curve.flow}</td>
                              <td className="centered">{curve.rpm}</td>
                              <td className="centered">{curve.size}</td>
                              <td className="centered">{curve.fileSize}</td>
                              <td className="centered">
                                <button className="product-pdf-download-btn">
                                  <DownloadIcon size={14} />
                                  PDF
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {selectedTab === 'technical' && (
            <div className="product-tab-panel">
              <div className="product-technical-content">
                <div className="product-drawing-section">
                  <h3 className="product-drawing-title">Drawing</h3>
                  <div className="product-drawings-list">
                    {[
                      { name: "8x6x14F & 8x6x15F 3800 Series", size: "384.65 kB" },
                      { name: "16x10x22F 3801 Series", size: "377 kB" },
                      { name: "16X10X22F 3802 Series", size: "1.6 MB" },
                      { name: "16X10X22F 3804 Series", size: "1.61 MB" }
                    ].map((drawing, index) => (
                      <div key={index} className="product-drawing-item">
                        <div className="product-drawing-name">
                          <a href="#" className="product-drawing-link">{drawing.name}</a>
                        </div>
                        <div className="product-drawing-download">
                          <button className="product-pdf-download-btn">
                            <DownloadIcon size={14} />
                            PDF
                          </button>
                          <span className="product-file-size">{drawing.size}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}


{selectedTab === 'documentation' && (
  <div className="product-tab-panel">
    <div className="product-documentation-content">
      
      {/* Brochures Section */}
      <div className="product-doc-section">
        <h3 className="product-doc-section-title">Brochures</h3>
        <div className="product-doc-item">
          <div className="product-doc-name">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/brochures/aurora-3800-series-single-stage-end-suction-pumps-brochure.pdf" 
              className="product-doc-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aurora 3800 Series Single Stage End Suction Pumps Brochure
            </a>
          </div>
          <div className="product-doc-download">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/brochures/aurora-3800-series-single-stage-end-suction-pumps-brochure.pdf"
              download="/public/AuroraEndSuctionBrochure.pdf"
              className="product-pdf-download-btn"
            >
              <DownloadIcon size={14} />
              PDF
            </a>
            <span className="product-file-size">2.49 MB</span>
          </div>
        </div>
      </div>

      {/* Manual Section */}
      <div className="product-doc-section">
        <h3 className="product-doc-section-title">Manual</h3>
        <div className="product-doc-item">
          <div className="product-doc-name">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/manuals/a-03-327-model-3801-3804-end-suction-pumps-iom.pdf" 
              className="product-doc-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Model 3801-3804 End Suction Pumps Installation, Operation & Maintenance Manual
            </a>
          </div>
          <div className="product-doc-download">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/manuals/a-03-327-model-3801-3804-end-suction-pumps-iom.pdf"
              download="3801-3804-installation-manual.pdf"
              className="product-pdf-download-btn"
            >
              <DownloadIcon size={14} />
              PDF
            </a>
            <span className="product-file-size">1.85 MB</span>
          </div>
        </div>
      </div>

      {/* Specifications Section */}
      <div className="product-doc-section">
        <h3 className="product-doc-section-title">Specifications</h3>
        <div className="product-doc-item">
          <div className="product-doc-name">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/spec-sheets/3801-specifications.docx" 
              className="product-doc-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              3801 Specifications
            </a>
          </div>
          <div className="product-doc-download">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/spec-sheets/3801-specifications.docx"
              download="3801-specifications.docx"
              className="product-pdf-download-btn"
            >
              <DownloadIcon size={14} />
              DOCX
            </a>
            <span className="product-file-size">245 KB</span>
          </div>
        </div>
        <div className="product-doc-item">
          <div className="product-doc-name">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/spec-sheets/3804-specifications.docx" 
              className="product-doc-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              3804 Specifications
            </a>
          </div>
          <div className="product-doc-download">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/spec-sheets/3804-specifications.docx"
              download="3804-specifications.docx"
              className="product-pdf-download-btn"
            >
              <DownloadIcon size={14} />
              DOCX
            </a>
            <span className="product-file-size">248 KB</span>
          </div>
        </div>
      </div>

      {/* Parts Section */}
      <div className="product-doc-section">
        <h3 className="product-doc-section-title">Parts</h3>
        <div className="product-doc-item">
          <div className="product-doc-name">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/repair-parts-indexes/a-03-345-3800-series-end-suction-pumps-rpi.pdf" 
              className="product-doc-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              3800 Series End Suction Pumps Repair Parts Index
            </a>
          </div>
          <div className="product-doc-download">
            <a 
              href="https://www.pentair.com/content/dam/extranet/web/nam/aurora/repair-parts-indexes/a-03-345-3800-series-end-suction-pumps-rpi.pdf"
              download="3800-series-repair-parts-index.pdf"
              className="product-pdf-download-btn"
            >
              <DownloadIcon size={14} />
              PDF
            </a>
            <span className="product-file-size">1.2 MB</span>
          </div>
        </div>
      </div>

    </div>
  </div>
)}

        </div>
      </div>

      <style jsx>{`
        /* Pump Filter Container Styles */
        .pump-filter-container {
          background: white;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
        }

        .filter-layout {
          display: flex;
          min-height: 600px;
        }

        /* Filter Sidebar */
        .filter-sidebar {
          width: 300px;
          background: #f8fafc;
          border-right: 1px solid #e5e7eb;
          flex-shrink: 0;
        }

        .filter-header {
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e5e7eb;
          background: white;
        }

        .filter-header h3 {
          margin: 0 0 0.5rem 0;
          font-size: 1rem;
          font-weight: 600;
          color: #374151;
        }

        .reset-btn {
          background: none;
          border: none;
          color: #2563eb;
          cursor: pointer;
          font-size: 0.875rem;
          text-decoration: underline;
          padding: 0;
          margin-right: 1rem;
        }

        .reset-btn:hover {
          color: #1d4ed8;
        }

        .results-count {
          font-weight: 600;
          color: #2563eb;
          font-size: 0.875rem;
        }

        /* Filter Sections */
        .filter-section {
          border-bottom: 1px solid #e5e7eb;
        }

        .filter-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.5rem;
          background: #f1f5f9;
          font-weight: 600;
          color: #374151;
          cursor: pointer;
          font-size: 0.875rem;
        }

        .expand-icon {
          color: #6b7280;
          font-size: 1rem;
        }

        .filter-options {
          padding: 1rem 1.5rem;
          background: white;
        }

        .filter-option {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
        }

        .filter-option:last-of-type {
          margin-bottom: 0;
        }

        .filter-option input[type="checkbox"] {
          display: none;
        }

        .checkbox-custom {
          width: 16px;
          height: 16px;
          border: 2px solid #d1d5db;
          border-radius: 3px;
          margin-right: 0.75rem;
          position: relative;
          flex-shrink: 0;
        }

        .filter-option input:checked + .checkbox-custom {
          background: #2563eb;
          border-color: #2563eb;
        }

        .filter-option input:checked + .checkbox-custom::after {
          content: '✓';
          position: absolute;
          top: -2px;
          left: 2px;
          color: white;
          font-size: 12px;
          font-weight: bold;
        }

        .option-text {
          color: #374151;
          line-height: 1.4;
        }

        .show-more-btn {
          background: none;
          border: none;
          color: #2563eb;
          cursor: pointer;
          font-size: 0.875rem;
          margin-top: 0.5rem;
          padding: 0;
        }

        .show-more-btn:hover {
          text-decoration: underline;
        }

        /* Curves Section */
        .curves-section {
          flex: 1;
          background: white;
        }

        .table-container {
          overflow-x: auto;
          height: 100%;
        }

        .curves-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.875rem;
        }

        .curves-table thead {
          background: #e5e7eb;
          position: sticky;
          top: 0;
          z-index: 10;
        }

        .curves-table th {
          padding: 0.75rem 1rem;
          text-align: left;
          font-weight: 600;
          color: #374151;
          border-bottom: 1px solid #d1d5db;
          white-space: nowrap;
        }

        .curve-column {
          width: 60px;
          text-align: center;
        }

        .curves-table td {
          padding: 0.75rem 1rem;
          border-bottom: 1px solid #f3f4f6;
          vertical-align: middle;
        }

        .even-row {
          background: #f9fafb;
        }

        .odd-row {
          background: white;
        }

        .curves-table tbody tr:hover {
          background: #e0f2fe !important;
        }

        .curve-cell {
          text-align: center;
          width: 60px;
        }

        .curve-icon {
          display: block;
          margin: 0 auto;
        }

        .product-name {
          font-weight: 500;
        }

        .product-link {
          color: #2563eb;
          text-decoration: none;
          font-weight: 500;
        }

        .product-link:hover {
          text-decoration: underline;
          color: #1d4ed8;
        }

        .centered {
          text-align: center;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .filter-layout {
            flex-direction: column;
          }

          .filter-sidebar {
            width: 100%;
          }

          .filter-header {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .filter-header h3 {
            margin: 0;
          }

          .curves-table {
            font-size: 0.8rem;
          }
        }

        @media (max-width: 768px) {
          .curves-table {
            min-width: 700px;
            font-size: 0.75rem;
          }

          .curves-table th,
          .curves-table td {
            padding: 0.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductPage;